import React from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './components/Sections/Home/Home';
// import Header from './components/Layout/Header/Header';
import Footer from './components/Layout/Footer/Footer';
import AboutUs from './components/Sections/AboutUs/AboutUs';
import WhatsApp from './components/Layout/WhatsApp/WhatsApp';
import NotFoundPage from './components/Layout/404/NotFoundPage';
import ScrollToTop from './components/Layout/ScrollToTop/ScrollToTop';
import ServicePage from './components/Sections/Services/ServicePage/ServicePage';
import Projects from './components/Sections/Projects/Projects';
import HeaderDos from './components/Layout/HeaderDos/HeaderDos';
import Contact from './components/Sections/Contact/Contact';
import Blog from './components/Sections/Blog/Blog';

const Router = () => {
    return (
        <BrowserRouter>
            <HeaderDos />
            {/* <Header /> */}
            <Routes>
                <Route exact path="/" element={<Home />} />
                <Route exact path='/about' element={<AboutUs />} />
                <Route path="/services/:slug" element={<ServicePage />} />
                <Route exact path="/projects" element={<Projects />} />
                <Route exact path="/blog" element={<Blog />} />
                <Route exact path="/contact" element={<Contact />} />
                <Route exact path="*" element={<NotFoundPage />} />
            </Routes>
            <Footer />
            <WhatsApp />
            <ScrollToTop />
        </BrowserRouter>
    )
}

export default Router